{
  "address": "jup3YeL8QhtSx1e253b2FDvsMNC87fDrgQZivbrndc9",
  "metadata": {
    "name": "lending",
    "version": "0.1.4",
    "spec": "0.1.0",
    "description": "Created with Anchor"
  },
  "instructions": [
    {
      "name": "deposit",
      "discriminator": [242, 35, 198, 137, 82, 225, 242, 182],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "assets",
          "type": "u64"
        }
      ],
      "returns": "u64"
    },
    {
      "name": "deposit_with_min_amount_out",
      "discriminator": [116, 144, 16, 97, 118, 109, 40, 119],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "assets",
          "type": "u64"
        },
        {
          "name": "min_amount_out",
          "type": "u64"
        }
      ]
    },
    {
      "name": "init_lending",
      "discriminator": [156, 224, 67, 46, 89, 189, 157, 209],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "lending_admin",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["token_reserves_liquidity"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  102, 95, 116, 111, 107, 101, 110, 95, 109, 105, 110, 116
                ]
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ]
          }
        },
        {
          "name": "metadata_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [109, 101, 116, 97, 100, 97, 116, 97]
              },
              {
                "kind": "const",
                "value": [
                  11, 112, 101, 177, 227, 209, 124, 69, 56, 157, 82, 127, 107,
                  4, 195, 205, 88, 184, 108, 115, 26, 160, 253, 181, 73, 182,
                  209, 188, 3, 248, 41, 70
                ]
              },
              {
                "kind": "account",
                "path": "f_token_mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                11, 112, 101, 177, 227, 209, 124, 69, 56, 157, 82, 127, 107, 4,
                195, 205, 88, 184, 108, 115, 26, 160, 253, 181, 73, 182, 209,
                188, 3, 248, 41, 70
              ]
            }
          }
        },
        {
          "name": "lending",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [108, 101, 110, 100, 105, 110, 103]
              },
              {
                "kind": "account",
                "path": "mint"
              },
              {
                "kind": "account",
                "path": "f_token_mint"
              }
            ]
          }
        },
        {
          "name": "token_reserves_liquidity"
        },
        {
          "name": "token_program"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        },
        {
          "name": "sysvar_instruction",
          "address": "Sysvar1nstructions1111111111111111111111111"
        },
        {
          "name": "metadata_program",
          "address": "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
        },
        {
          "name": "rent",
          "address": "SysvarRent111111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "symbol",
          "type": "string"
        },
        {
          "name": "liquidity_program",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "init_lending_admin",
      "discriminator": [203, 185, 241, 165, 56, 254, 33, 9],
      "accounts": [
        {
          "name": "authority",
          "writable": true,
          "signer": true
        },
        {
          "name": "lending_admin",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "const",
                "value": [
                  108, 101, 110, 100, 105, 110, 103, 95, 97, 100, 109, 105, 110
                ]
              }
            ]
          }
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "liquidity_program",
          "type": "pubkey"
        },
        {
          "name": "rebalancer",
          "type": "pubkey"
        },
        {
          "name": "authority",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "mint",
      "discriminator": [51, 57, 225, 47, 182, 146, 137, 166],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "shares",
          "type": "u64"
        }
      ],
      "returns": "u64"
    },
    {
      "name": "mint_with_max_assets",
      "discriminator": [6, 94, 69, 122, 30, 179, 146, 171],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "shares",
          "type": "u64"
        },
        {
          "name": "max_assets",
          "type": "u64"
        }
      ],
      "returns": "u64"
    },
    {
      "name": "rebalance",
      "discriminator": [108, 158, 77, 9, 210, 52, 88, 62],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "signer"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model",
          "writable": true
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": []
    },
    {
      "name": "rebalance_with_amounts",
      "discriminator": [190, 33, 144, 182, 86, 4, 141, 73],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "depositor_token_account",
          "writable": true,
          "pda": {
            "seeds": [
              {
                "kind": "account",
                "path": "signer"
              },
              {
                "kind": "account",
                "path": "token_program"
              },
              {
                "kind": "account",
                "path": "mint"
              }
            ],
            "program": {
              "kind": "const",
              "value": [
                140, 151, 37, 143, 78, 36, 137, 241, 187, 61, 16, 41, 20, 142,
                13, 131, 11, 90, 19, 153, 218, 255, 16, 132, 4, 142, 123, 216,
                219, 233, 248, 89
              ]
            }
          }
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model",
          "writable": true
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": {
            "option": "u64"
          }
        }
      ]
    },
    {
      "name": "redeem",
      "discriminator": [184, 12, 86, 149, 70, 196, 97, 225],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "owner_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "claim_account",
          "writable": true,
          "optional": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "shares",
          "type": "u64"
        }
      ],
      "returns": "u64"
    },
    {
      "name": "redeem_with_min_amount_out",
      "discriminator": [235, 189, 237, 56, 166, 180, 184, 149],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "owner_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "claim_account",
          "writable": true,
          "optional": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "shares",
          "type": "u64"
        },
        {
          "name": "min_amount_out",
          "type": "u64"
        }
      ]
    },
    {
      "name": "set_rewards_rate_model",
      "discriminator": [174, 231, 116, 203, 8, 58, 143, 203],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "f_token_mint",
          "relations": ["lending"]
        },
        {
          "name": "new_rewards_rate_model"
        },
        {
          "name": "supply_token_reserves_liquidity"
        }
      ],
      "args": [
        {
          "name": "mint",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "update_authority",
      "discriminator": [32, 46, 64, 28, 149, 75, 243, 88],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "lending_admin",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "new_authority",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "update_auths",
      "discriminator": [93, 96, 178, 156, 57, 117, 253, 209],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "lending_admin",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "auth_status",
          "type": {
            "vec": {
              "defined": {
                "name": "AddressBool"
              }
            }
          }
        }
      ]
    },
    {
      "name": "update_rate",
      "discriminator": [24, 225, 53, 189, 72, 212, 225, 178],
      "accounts": [
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "supply_token_reserves_liquidity"]
        },
        {
          "name": "f_token_mint",
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity"
        },
        {
          "name": "rewards_rate_model"
        }
      ],
      "args": []
    },
    {
      "name": "update_rebalancer",
      "discriminator": [206, 187, 54, 228, 145, 8, 203, 111],
      "accounts": [
        {
          "name": "signer",
          "signer": true
        },
        {
          "name": "lending_admin",
          "writable": true
        }
      ],
      "args": [
        {
          "name": "new_rebalancer",
          "type": "pubkey"
        }
      ]
    },
    {
      "name": "withdraw",
      "discriminator": [183, 18, 70, 156, 148, 109, 161, 34],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "owner_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "claim_account",
          "writable": true,
          "optional": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        }
      ],
      "returns": "u64"
    },
    {
      "name": "withdraw_with_max_shares_burn",
      "discriminator": [47, 197, 183, 171, 239, 18, 245, 171],
      "accounts": [
        {
          "name": "signer",
          "writable": true,
          "signer": true
        },
        {
          "name": "owner_token_account",
          "writable": true
        },
        {
          "name": "recipient_token_account",
          "writable": true
        },
        {
          "name": "lending_admin"
        },
        {
          "name": "lending",
          "writable": true
        },
        {
          "name": "mint",
          "relations": ["lending", "rewards_rate_model"]
        },
        {
          "name": "f_token_mint",
          "writable": true,
          "relations": ["lending"]
        },
        {
          "name": "supply_token_reserves_liquidity",
          "writable": true
        },
        {
          "name": "lending_supply_position_on_liquidity",
          "writable": true
        },
        {
          "name": "rate_model"
        },
        {
          "name": "vault",
          "writable": true
        },
        {
          "name": "claim_account",
          "writable": true,
          "optional": true
        },
        {
          "name": "liquidity",
          "writable": true
        },
        {
          "name": "liquidity_program",
          "relations": ["lending_admin"]
        },
        {
          "name": "rewards_rate_model"
        },
        {
          "name": "token_program"
        },
        {
          "name": "associated_token_program",
          "optional": true,
          "address": "ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL"
        },
        {
          "name": "system_program",
          "address": "11111111111111111111111111111111"
        }
      ],
      "args": [
        {
          "name": "amount",
          "type": "u64"
        },
        {
          "name": "max_shares_burn",
          "type": "u64"
        }
      ],
      "returns": "u64"
    }
  ],
  "accounts": [
    {
      "name": "Lending",
      "discriminator": [135, 199, 82, 16, 249, 131, 182, 241]
    },
    {
      "name": "LendingAdmin",
      "discriminator": [42, 8, 33, 220, 163, 40, 210, 5]
    },
    {
      "name": "LendingRewardsRateModel",
      "discriminator": [166, 72, 71, 131, 172, 74, 166, 181]
    },
    {
      "name": "TokenReserve",
      "discriminator": [21, 18, 59, 135, 120, 20, 31, 12]
    },
    {
      "name": "UserSupplyPosition",
      "discriminator": [202, 219, 136, 118, 61, 177, 21, 146]
    }
  ],
  "events": [
    {
      "name": "LogDeposit",
      "discriminator": [176, 243, 1, 56, 142, 206, 1, 106]
    },
    {
      "name": "LogRebalance",
      "discriminator": [90, 67, 219, 41, 181, 118, 132, 9]
    },
    {
      "name": "LogUpdateAuthority",
      "discriminator": [150, 152, 157, 143, 6, 135, 193, 101]
    },
    {
      "name": "LogUpdateAuths",
      "discriminator": [88, 80, 109, 48, 111, 203, 76, 251]
    },
    {
      "name": "LogUpdateRates",
      "discriminator": [222, 11, 113, 60, 147, 15, 68, 217]
    },
    {
      "name": "LogUpdateRebalancer",
      "discriminator": [66, 79, 144, 204, 26, 217, 153, 225]
    },
    {
      "name": "LogUpdateRewards",
      "discriminator": [37, 13, 111, 186, 47, 245, 162, 121]
    },
    {
      "name": "LogWithdraw",
      "discriminator": [49, 9, 176, 179, 222, 190, 6, 117]
    }
  ],
  "errors": [
    {
      "code": 6000,
      "name": "FTokenDepositInsignificant",
      "msg": "F_TOKEN_DEPOSIT_INSIGNIFICANT"
    },
    {
      "code": 6001,
      "name": "FTokenMinAmountOut",
      "msg": "F_TOKEN_MIN_AMOUNT_OUT"
    },
    {
      "code": 6002,
      "name": "FTokenMaxAmount",
      "msg": "F_TOKEN_MAX_AMOUNT"
    },
    {
      "code": 6003,
      "name": "FTokenInvalidParams",
      "msg": "F_TOKEN_INVALID_PARAMS"
    },
    {
      "code": 6004,
      "name": "FTokenRewardsRateModelAlreadySet",
      "msg": "F_TOKEN_REWARDS_RATE_MODEL_ALREADY_SET"
    },
    {
      "code": 6005,
      "name": "FTokenMaxAuthCountReached",
      "msg": "F_TOKEN_MAX_AUTH_COUNT"
    },
    {
      "code": 6006,
      "name": "FTokenLiquidityExchangePriceUnexpected",
      "msg": "F_TOKEN_LIQUIDITY_EXCHANGE_PRICE_UNEXPECTED"
    },
    {
      "code": 6007,
      "name": "FTokenCpiToLiquidityFailed",
      "msg": "F_TOKEN_CPI_TO_LIQUIDITY_FAILED"
    },
    {
      "code": 6008,
      "name": "FTokenOnlyAuth",
      "msg": "F_TOKEN_ONLY_AUTH"
    },
    {
      "code": 6009,
      "name": "FTokenOnlyAuthority",
      "msg": "F_TOKEN_ONLY_AUTHORITY"
    },
    {
      "code": 6010,
      "name": "FTokenOnlyRebalancer",
      "msg": "F_TOKEN_ONLY_REBALANCER"
    },
    {
      "code": 6011,
      "name": "FTokenUserSupplyPositionRequired",
      "msg": "F_TOKEN_USER_SUPPLY_POSITION_REQUIRED"
    },
    {
      "code": 6012,
      "name": "FTokenLiquidityProgramMismatch",
      "msg": "F_TOKEN_LIQUIDITY_PROGRAM_MISMATCH"
    }
  ],
  "types": [
    {
      "name": "AddressBool",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "addr",
            "type": "pubkey"
          },
          {
            "name": "value",
            "type": "bool"
          }
        ]
      }
    },
    {
      "name": "Lending",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "f_token_mint",
            "type": "pubkey"
          },
          {
            "name": "lending_id",
            "type": "u16"
          },
          {
            "name": "decimals",
            "docs": ["@dev number of decimals for the fToken, same as ASSET"],
            "type": "u8"
          },
          {
            "name": "rewards_rate_model",
            "docs": [
              "@dev To read PDA of rewards rate model to get_rate instruction"
            ],
            "type": "pubkey"
          },
          {
            "name": "liquidity_exchange_price",
            "docs": [
              "@dev exchange price for the underlying asset in the liquidity protocol (without rewards)"
            ],
            "type": "u64"
          },
          {
            "name": "token_exchange_price",
            "docs": [
              "@dev exchange price between fToken and the underlying asset (with rewards)"
            ],
            "type": "u64"
          },
          {
            "name": "last_update_timestamp",
            "docs": [
              "@dev timestamp when exchange prices were updated the last time"
            ],
            "type": "u64"
          },
          {
            "name": "token_reserves_liquidity",
            "type": "pubkey"
          },
          {
            "name": "supply_position_on_liquidity",
            "type": "pubkey"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "LendingAdmin",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "authority",
            "type": "pubkey"
          },
          {
            "name": "liquidity_program",
            "type": "pubkey"
          },
          {
            "name": "rebalancer",
            "type": "pubkey"
          },
          {
            "name": "next_lending_id",
            "type": "u16"
          },
          {
            "name": "auths",
            "type": {
              "vec": "pubkey"
            }
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "LendingRewardsRateModel",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "docs": ["@dev mint address"],
            "type": "pubkey"
          },
          {
            "name": "start_tvl",
            "docs": [
              "@dev tvl below which rewards rate is 0. If current TVL is below this value, triggering `update_rate()` on the fToken",
              "might bring the total TVL above this cut-off."
            ],
            "type": "u64"
          },
          {
            "name": "duration",
            "docs": ["@dev for how long current rewards should run"],
            "type": "u64"
          },
          {
            "name": "start_time",
            "docs": ["@dev when current rewards got started"],
            "type": "u64"
          },
          {
            "name": "yearly_reward",
            "docs": [
              "@dev current annualized reward based on input params (duration, rewardAmount)"
            ],
            "type": "u64"
          },
          {
            "name": "next_duration",
            "docs": ["@dev Duration for the next rewards phase"],
            "type": "u64"
          },
          {
            "name": "next_reward_amount",
            "docs": ["@dev Amount of rewards for the next phase"],
            "type": "u64"
          },
          {
            "name": "bump",
            "type": "u8"
          }
        ]
      }
    },
    {
      "name": "LogDeposit",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "sender",
            "type": "pubkey"
          },
          {
            "name": "receiver",
            "type": "pubkey"
          },
          {
            "name": "assets",
            "type": "u64"
          },
          {
            "name": "shares_minted",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "LogRebalance",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "assets",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "LogUpdateAuthority",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "new_authority",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "LogUpdateAuths",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "auth_status",
            "type": {
              "vec": {
                "defined": {
                  "name": "AddressBool"
                }
              }
            }
          }
        ]
      }
    },
    {
      "name": "LogUpdateRates",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "token_exchange_price",
            "type": "u64"
          },
          {
            "name": "liquidity_exchange_price",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "LogUpdateRebalancer",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "new_rebalancer",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "LogUpdateRewards",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "rewards_rate_model",
            "type": "pubkey"
          }
        ]
      }
    },
    {
      "name": "LogWithdraw",
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "sender",
            "type": "pubkey"
          },
          {
            "name": "receiver",
            "type": "pubkey"
          },
          {
            "name": "owner",
            "type": "pubkey"
          },
          {
            "name": "assets",
            "type": "u64"
          },
          {
            "name": "shares_burned",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "TokenReserve",
      "docs": ["Token configuration and exchange prices"],
      "serialization": "bytemuck",
      "repr": {
        "kind": "c",
        "packed": true
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "vault",
            "type": "pubkey"
          },
          {
            "name": "borrow_rate",
            "type": "u16"
          },
          {
            "name": "fee_on_interest",
            "type": "u16"
          },
          {
            "name": "last_utilization",
            "type": "u16"
          },
          {
            "name": "last_update_timestamp",
            "type": "u64"
          },
          {
            "name": "supply_exchange_price",
            "type": "u64"
          },
          {
            "name": "borrow_exchange_price",
            "type": "u64"
          },
          {
            "name": "max_utilization",
            "type": "u16"
          },
          {
            "name": "total_supply_with_interest",
            "type": "u64"
          },
          {
            "name": "total_supply_interest_free",
            "type": "u64"
          },
          {
            "name": "total_borrow_with_interest",
            "type": "u64"
          },
          {
            "name": "total_borrow_interest_free",
            "type": "u64"
          },
          {
            "name": "total_claim_amount",
            "type": "u64"
          },
          {
            "name": "interacting_protocol",
            "type": "pubkey"
          },
          {
            "name": "interacting_timestamp",
            "type": "u64"
          },
          {
            "name": "interacting_balance",
            "type": "u64"
          }
        ]
      }
    },
    {
      "name": "UserSupplyPosition",
      "docs": ["User supply position"],
      "serialization": "bytemuck",
      "repr": {
        "kind": "c",
        "packed": true
      },
      "type": {
        "kind": "struct",
        "fields": [
          {
            "name": "protocol",
            "type": "pubkey"
          },
          {
            "name": "mint",
            "type": "pubkey"
          },
          {
            "name": "with_interest",
            "type": "u8"
          },
          {
            "name": "amount",
            "type": "u64"
          },
          {
            "name": "withdrawal_limit",
            "type": "u64"
          },
          {
            "name": "decay_amount",
            "type": "u64"
          },
          {
            "name": "last_update",
            "type": "u64"
          },
          {
            "name": "expand_pct",
            "type": "u16"
          },
          {
            "name": "expand_duration",
            "type": "u32"
          },
          {
            "name": "decay_duration",
            "type": "u32"
          },
          {
            "name": "base_withdrawal_limit",
            "type": "u64"
          },
          {
            "name": "status",
            "type": "u8"
          }
        ]
      }
    }
  ]
}
